import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectField} from 'components';
import { FormControl, Button, Grid2 } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { getRequestList, deleteRequestAction  } from '../actions/LockdownAggregationActions';
import { enqueueSnackbar } from 'actions';

const DeleteRequestForm = () => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();
	const [requests, setRequests] = useState([]);
	const [selectedRequest, setSelectedRequest] = useState('');

	// Função para carregar os requests
	const loadRequestsList = async () => {
		try {
			const data = await getRequestList(); // Chama o endpoint para buscar requests
			setRequests(data); // Atualiza o estado com os dados mais recentes
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `Failed to load cluster list: ${error}`, options: { variant: 'error' } }));
		}
	};

	// Chamar a action diretamente no useEffect
	useEffect(() => {
		loadRequestsList();
	}, []);

	const handleDelete = async () => {
		if (!selectedRequest) {
			dispatch(enqueueSnackbar({ message: 'Please select a cluster to delete.', options: { variant: 'error' } }));
			return;
		}

		const confirmDelete = window.confirm(`Are you sure you want to delete ${selectedRequest}?`);

		if (confirmDelete) {
			try {
				await deleteRequestAction(userId, selectedRequest); // Chama a action para excluir
				setSelectedRequest(''); // Limpa a seleção

				dispatch(enqueueSnackbar({ message: `Deleted cluster: ${selectedRequest}`, options: { variant: 'success' } }));

				await loadRequestsList(); // Recarrega a lista de requests após a exclusão
			} catch (error) {
				dispatch(enqueueSnackbar({ message: `Failed to delete cluster: ${error}`, options: { variant: 'error' } }));
			}
		}
	};

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<FormControl fullWidth>
					<SelectField
						id="inputRequest"
						name="inputRequest"
						value={selectedRequest}
						onChange={(e) => setSelectedRequest(e.target.value)}
						hintText="Select a cluster to Delete"
						menuItems={requests.map((request) => ({
							value: request.name,
							text: request.name,
						}))} // Mapeia os resultados para `menuItems`
					/>
				</FormControl>
			</Grid2>
			<Grid2 item size={12}>
				<Button
					variant="contained"
					color="error"
					fullWidth
					startIcon={<DeleteIcon />}
					onClick={handleDelete}
				>
					Delete
				</Button>
			</Grid2>
		</Grid2>
	);
};

export default DeleteRequestForm;